import { transport } from 'config/transport';

export function callApiGetListOfThuChiMamNon(congDoanId, academicYear) {
    return transport.get(`/congdoan/${congDoanId}/thuchi/thudaunam/academicYear/${academicYear}`);
}
